import { render, staticRenderFns } from "./forumSearch.vue?vue&type=template&id=57d3fe50&scoped=true&"
import script from "./forumSearch.vue?vue&type=script&lang=js&"
export * from "./forumSearch.vue?vue&type=script&lang=js&"
import style0 from "./forumSearch.vue?vue&type=style&index=0&lang=css&"
import style1 from "./forumSearch.vue?vue&type=style&index=1&id=57d3fe50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d3fe50",
  null
  
)

export default component.exports